import _orderBy from 'lodash/orderBy';

export const sortClientLandingList = (data, sortingOrder) => {
  if (sortingOrder === 'By Field Order') return data;
  return _orderBy(data, ['fields.calculatedAverageRating'], ['desc']);
};
